var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Ruler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2 6 C 0.9069372 6 0 6.9069372 0 8 L 0 16 C 0 17.093063 0.9069372 18 2 18 L 22 18 C 23.093063 18 24 17.093063 24 16 L 24 8 C 24 6.9069372 23.093063 6 22 6 L 2 6 z M 2 8 L 3 8 L 3 10 L 5 10 L 5 8 L 7 8 L 7 12 L 9 12 L 9 8 L 11 8 L 11 10 L 13 10 L 13 8 L 15 8 L 15 12 L 17 12 L 17 8 L 19 8 L 19 10 L 21 10 L 21 8 L 22 8 L 22 16 L 2 16 L 2 8 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Ruler);
export default __webpack_public_path__ + "static/media/icons8-ruler.3567e14f.svg";
export { ForwardRef as ReactComponent };